<template>
    <div class="main">
        <!-- 頁首 -->
        <Header :title="title" :isBack="true" />

        <!-- 主體 -->
        <div class="mainContent">

            <!-- 智慧農場 -->
            <div class="agri-result-group pwa pb-1">
                <b-container> 
                    <!-- 標題 -->  
                    <PwaTitle :textTitle="group_data.title" :showMore="false"></PwaTitle>
                    <!-- 清單 --> 
                    <OptionsGroup>
                        <template v-for="(data, index) in group_data.list">
                            <OptionsItem :key="`item-${index}`" classIcon="fa fa-map-marker" :textTitle="data.crop" @clickItem="goWeatherSensingInfo(data)" />
                            <hr v-if="index !== group_data.list.length - 1" :key="`divider-${index}`" />
                        </template>
                    </OptionsGroup>  
                </b-container>
            </div> 

        </div>

    </div>
</template>
<script>
import Header from '@/components/pwa/Header.vue'
import PwaTitle from '@/components/pwa/PwaTitle.vue'
import OptionsGroup from '@/components/pwa/OptionsGroup.vue'
import OptionsItem from '@/components/pwa/OptionsItem.vue'
export default {
    created() {
        window.vue = this;
        if(!window.checkLogin()){ window.setPage("login");}               
    },  
    components: {
        Header,
        PwaTitle,
        OptionsGroup,
        OptionsItem
    },
    data(){
        return {
            title: "氣象預報服務專區",
            select:{
                //縣市 id 
                city_id:"",
                //縣市 name 
                city_name:"",
                //縣市 token 
                city_token:"",
    
                //預報點(鄉鎮)
                town:"",
                //預報點(識別碼)
                id:"",
                //預報點(token)
                token:"",
                //預報點(名稱)
                crop:"",
                //預報點類型
                level:"農業氣象站",
            },
            group_data:{
                title:"農業氣象站",
                list:[],
                clear:{
                    title:"清除暫存資料",
                }
            },

            //農業氣象觀測-取得縣市清單
            apiGetCitySelect: (data) => this.userRequest.get("API/Default/GetCitySelect", data),
            //農業氣象觀測-取得預報點名稱
            apiGetCropStation: (data) => this.userRequest.get("API/Default/GetCropStation?city_token=" + this.select.city_token + "&level=" + this.select.level, data),
        }
    },
    mounted() {

        //農業氣象觀測-取得縣市清單
        this.apiCitySelect({}); 
    },
    methods: {

        //農業氣象觀測-取得縣市清單
        apiCitySelect(data){
        
            this.apiGetCitySelect(data)
            .then((res) => {

                const result = JSON.parse(res.data);
                for(var i=0 ; i<result.length ; i++)
                {
                    var item = result[i];
                    if(item.name == "雲林縣")
                    {  
                        this.select.city_id = item.county_id;
                        this.select.city_name = item.name;
                        this.select.city_token = item.token;
                        //農業氣象觀測-取得預報點名稱 
                        this.apiCropStation({ }); 
                    }
                }
            })
            .catch((err) => {
                console.log(err);
            }); 
        },

        //農業氣象觀測-取得預報點名稱
        apiCropStation(data){
        
            this.apiGetCropStation(data)
            .then((res) => {

                const result = JSON.parse(res.data);  
                this.group_data.list = [];
                if(result.result.length > 0)
                {
                    this.group_data.list = result.result;
                    console.log(this.group_data.list);
                    for(var i=0 ; i<result.result.length ; i++)
                    {
                        var item = result.result[i];
                        console.log(item);
                        //預設選取第一個
                        /*
                        if(i == 0)
                        {
                            this.main_menu.cropstation_forecast.select.token = item.token;
                        }

                        this.main_menu.cropstation_forecast.input.location.list.push({

                            value:item.id,
                            text:item.crop
                        });
                        */
                    }
                }
            })
            .catch((err) => {
                console.log(err);
            }); 

        },

        //前往 氣象預報服務專區(資訊)
        goWeatherSensingInfo(data){
            window.location = "pwa.html#/PwaWeatherSensingInfo?title=" + data.crop + "&token=" + data.token + "&level=" + data.level + "&station_id=" + data.id;
        }
    }
}
</script>
<style scoped>

</style>